import { render } from "./ItemProductMinera.vue?vue&type=template&id=0576522a"
import script from "./ItemProductMinera.vue?vue&type=script&lang=js"
export * from "./ItemProductMinera.vue?vue&type=script&lang=js"

import "./ItemProductMinera.vue?vue&type=style&index=0&id=0576522a&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__